// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateWheelPicker_wrapper__NFXfe {
  display: flex;
  justify-content: center;
  position: relative;
  gap: 30px;
  margin-top: 16px;
  overflow: hidden;
  height: 200px;
}

.DateWheelPicker_wheel__lx2iZ {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 60px;
  height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-snap-type: y mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
  text-align: center;
  color: rgba(255, 255, 255, 0.5); /* Полупрозрачный текст по умолчанию */
  font-size: 18px;
  touch-action: pan-y;
  position: relative;
}

.DateWheelPicker_wheel__lx2iZ::-webkit-scrollbar {
  display: none;
}

.DateWheelPicker_wheel__lx2iZ li {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: center;
  transition: color 0.2s, font-size 0.2s, font-weight 0.2s;
}

/* Только активный элемент — белый и жирный */
.DateWheelPicker_wheel__lx2iZ li.DateWheelPicker_active__D39f4 {
  color: #fff;
  font-weight: 600;
  font-size: 20px;
}

.DateWheelPicker_highlight__fPFlT {
  position: absolute;
  top: 80px; /* Центрирование для item height 40px */
  width: 100%;
  height: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  pointer-events: none;
  z-index: 2;
}

.DateWheelPicker_stub__kIyo6 {
  height: 40px; /* такой же, как ITEM_HEIGHT               */
  pointer-events: none; /* не ловит клики/скролл                   */
  background: transparent;
}

.DateWheelPicker_fadeTop__6ty0\\+,
.DateWheelPicker_fadeBottom__Y7y7q {
  position: absolute;
  width: 100%;
  height: 60px;
  pointer-events: none;
  z-index: 1;
}

.DateWheelPicker_fadeBottom__Y7y7q {
  top: auto;
  bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/DateWheelPicker/DateWheelPicker.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B,EAAE,sCAAsC;EACvE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,uCAAuC;EAClD,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY,EAAE,4CAA4C;EAC1D,oBAAoB,EAAE,4CAA4C;EAClE,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,SAAS;AACX","sourcesContent":[".wrapper {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  gap: 30px;\n  margin-top: 16px;\n  overflow: hidden;\n  height: 200px;\n}\n\n.wheel {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 60px;\n  height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scroll-snap-type: y mandatory;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5); /* Полупрозрачный текст по умолчанию */\n  font-size: 18px;\n  touch-action: pan-y;\n  position: relative;\n}\n\n.wheel::-webkit-scrollbar {\n  display: none;\n}\n\n.wheel li {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  scroll-snap-align: center;\n  transition: color 0.2s, font-size 0.2s, font-weight 0.2s;\n}\n\n/* Только активный элемент — белый и жирный */\n.wheel li.active {\n  color: #fff;\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.highlight {\n  position: absolute;\n  top: 80px; /* Центрирование для item height 40px */\n  width: 100%;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.stub {\n  height: 40px; /* такой же, как ITEM_HEIGHT               */\n  pointer-events: none; /* не ловит клики/скролл                   */\n  background: transparent;\n}\n\n.fadeTop,\n.fadeBottom {\n  position: absolute;\n  width: 100%;\n  height: 60px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.fadeBottom {\n  top: auto;\n  bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `DateWheelPicker_wrapper__NFXfe`,
	"wheel": `DateWheelPicker_wheel__lx2iZ`,
	"active": `DateWheelPicker_active__D39f4`,
	"highlight": `DateWheelPicker_highlight__fPFlT`,
	"stub": `DateWheelPicker_stub__kIyo6`,
	"fadeTop": `DateWheelPicker_fadeTop__6ty0+`,
	"fadeBottom": `DateWheelPicker_fadeBottom__Y7y7q`
};
export default ___CSS_LOADER_EXPORT___;
